export default "__VITE_ASSET__3e634bf9__"